import { Modal } from "antd";
import { Formik } from "formik";
import { useState } from "react";
import { useSelector } from "react-redux";
import { addBotSchema } from "../../utils/schema";
import ErrorMessage from "../../components/ErrorMessage";

const AddBotModel = (props) => {
  const [design_type, setDesign_type] = useState();
  const [bot_type_id, setBot_type_id] = useState(null);
  const [weight_class_id, setWeight_class_id] = useState(null);

  const { botTypes, weightClassCategories } = useSelector(
    (state) => state.authReducer
  );
  const {
    isAddBotModalOpen,
    setIsAddBotModalOpen,
    hadnleAddBotSubmit,
    user,
    isSubmitButton,
    setIsSubmitButton,
  } = props ?? {};

  const initialValues = {
    start_date: "",
    name: "",
    image: "",
    description: "",
  };

  const handleAddBot = (values) => {
    if(isSubmitButton){
      return 
    }
    setIsSubmitButton(true)
    const data = {
      ...values,
      created_by: user?.id,
      bot_type_id,
      design_type,
      weight_class_id,
    };

    const formdata = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (key === "image") {
        if (value instanceof File) {
          formdata.append(key, value);
        }
      } else {
        formdata.append(key, value ?? "");
      }
    });
    hadnleAddBotSubmit(formdata);
  };

  return (
    <>
      <Modal
        title={``}
        className="w-100"
        style={{ maxWidth: "800px" }}
        centered={true}
        open={isAddBotModalOpen}
        onCancel={() => {
          setIsAddBotModalOpen(false);
        }}
        footer={null}
      >
        <div className="mt-4">
          <div
            class="modal-dialog modal-dialog-centered mx-0"
            style={{ maxWidth: "100%" }}
          >
            <div class="modal-content border-0">
              <div class="modal-body py-0">
                <h4 className="ct_fs_24 text-center mb-4">Add Bot</h4>
                <Formik
                  initialValues={initialValues}
                  validationSchema={addBotSchema}
                  onSubmit={(values, actions) => {
                    handleAddBot(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    handleSubmit,
                  }) => (
                    <form
                      onSubmit={handleSubmit}
                      className="ct_free_account_overflow px-3"
                      style={{ overflowX: "hidden" }}
                    >
                      {/* Image Input */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Bot Image
                        </label>
                        <label for="ct_team_upload_img" className="d-block">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(event) => {
                              const file = event.currentTarget.files[0];
                              setTouched({ image: true });
                              setFieldValue("image", file);
                            }}
                            onBlur={handleBlur}
                            className="form-control d-none"
                            id="ct_team_upload_img"
                          />
                          <div className="ct_team_upload_box_23">
                            <p className="text-center mb-0 ct_fs_18">
                              Upload Image here
                            </p>

                            {values?.image && (
                              <img
                                src={
                                  typeof values.image === "string"
                                    ? values.image
                                    : URL.createObjectURL(values.image)
                                }
                                className="ct_uploded_img"
                                alt="Uploaded Preview"
                              />
                            )}
                          </div>
                        </label>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="image"
                        />
                      </div>
                      {/* Bot Name */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Bot Name <span className="ct_red_text">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter bot name"
                          className="form-control"
                          value={values.name}
                          id="name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />

                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="name"
                        />
                      </div>
                      <div className="row">
                        {/* Weight class */}
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-2 d-block ct_fw_600">
                              Weight class
                            </label>
                            <select
                              className="form-control"
                              onChange={(e) => {
                                const selectedItem = weightClassCategories.find(
                                  (item) => item.name === e.target.value
                                );
                                setWeight_class_id(
                                  selectedItem ? selectedItem.id : null
                                );
                              }}
                            >
                              <option value="" disabled selected>
                                Select Weight Class
                              </option>
                              {weightClassCategories?.map((item) => (
                                <option key={item.id} value={item.name}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* Bot Type */}
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-2 d-block ct_fw_600">
                              Bot Type
                            </label>
                            <select
                              className="form-control"
                              onChange={(e) => {
                                const selectedBot = botTypes.find(
                                  (bot) => bot.name === e.target.value
                                );
                                setBot_type_id(
                                  selectedBot ? selectedBot.id : null
                                );
                              }}
                            >
                              <option value="" disabled selected>
                                Select Bot
                              </option>
                              {botTypes?.map((bot) => (
                                <option key={bot.id} value={bot.name}>
                                  {bot.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* Design Type */}
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-2 d-block ct_fw_600">
                              Design Type
                            </label>
                            <select
                              onChange={(e) => {
                                setDesign_type(e.target.value);
                              }}
                              value={design_type}
                              className="form-control"
                            >
                              <option value={""} selected disabled>
                                Selected Design Type
                              </option>
                              <option value={"Custom"}>Custom</option>
                              <option value={"Kit"}>Kit</option>
                            </select>
                          </div>
                        </div>
                        {/* Date Started Competing */}
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-2 d-block ct_fw_600">
                              Date Started Competing
                            </label>
                            <input
                              type="date"
                              className="form-control"
                          
                              value={values.start_date}
                              id="start_date"
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />

                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="start_date"
                            />
                          </div>
                        </div>
                        {/* Description Input*/}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Description
                          </label>
                          <textarea
                            className="form-control"
                            rows={4}
                            placeholder="Enter Description"
                            value={values.description}
                            id="description"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="description"
                          />
                        </div>
                      </div>
                      {/* Submit button */}
                      <div className="text-center mt-4">
                        <button
                          onClick={handleSubmit}
                          type="button"
                          className="btn btn-secondary ct_btn_animate px-5"
                        >
                          {" "}
                          Save
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddBotModel;
